// @flow
import * as React from 'react';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import DidYouMeanBanner from '../DidYouMeanBanner';
import messages from '../../messages';
import styles from './listHeadStyles';
import { SearchTitle } from '../../../components/shared/Titles';

type Props = {
  showFilters: Function,
  count: number,
  appliedFiltersCount: number,
  searchParameters: Object,
  wrongWhat: ?string,
};

const { nResults, filtersTitle } = messages;

export default function ListHead({
  showFilters,
  count,
  appliedFiltersCount,
  searchParameters,
  wrongWhat,
}: Props): React.Node {
  const filtersCount = appliedFiltersCount > 0 ? `(${appliedFiltersCount})` : '';
  const resultClass = count === 0 ? 'empty' : '';
  const where = get(searchParameters, 'where');
  const what = get(searchParameters, 'what_d');

  return (
    <div className="listHead">
      {wrongWhat ? (
        <DidYouMeanBanner where={where} correctWhat={what} wrongWhat={wrongWhat} />
      ) : (
        <SearchTitle />
      )}
      <p>
        <a className="filter" onClick={showFilters} data-test="open-filters">
          <FormattedMessage {...filtersTitle} /> {filtersCount} &raquo;
        </a>
        <span data-test="results" className={`results ${resultClass}`}>
          {count} <FormattedMessage {...nResults} />
        </span>
      </p>

      <style jsx>{styles}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/Serp/components/ListHead/ListHead.js